/* eslint-disable @typescript-eslint/no-explicit-any */
import { oc } from 'ts-optchain';

import { Need } from 'types/service';
import { dashboard } from 'types';
import { getConfig, saveConfig } from 'utils/service/localStorageUtils';
import { map, sortBy } from 'es-toolkit/compat';

export interface ServiceDefinedState {
  primaryState: dashboard.PartyState;
  stateName: string;
  color: string;
  pantryColor?: string;
  ordering: number;
  icon?: string;
  border?: string;
}

interface State {
  businessDefinedStates: ServiceDefinedState[];
  configuredTags: any;
  serviceNeeds: Need[];
  setDirtyAfterLeft: any;
  textingAvailable: boolean;
  textingEnabled: boolean;
  textMessageDefaults: dashboard.TextMessageDefault[];
}

const defaultState: State = {
  businessDefinedStates: [],
  configuredTags: null,
  serviceNeeds: [],
  setDirtyAfterLeft: null,
  textingAvailable: false,
  textingEnabled: false,
  textMessageDefaults: [],
};

export const initialState = {
  ...defaultState,
  ...getConfig(),
};

export default function config(state = initialState, action: BaseTockAction): State {
  const { type, payload } = action;
  switch (type) {
    case 'SET_CONFIG': {
      // Calling map on null returns an empty array
      const businessDefinedStates = sortBy(
        map(payload.businessDefinedState, (state) => {
          return {
            primaryState: state.primaryState,
            stateName: state.secondaryState,
            color: state.color,
            pantryColor: state.pantryColor,
            ordering: state.ordering,
            icon: state.icon,
            border: state.border,
          };
        }),
        'ordering'
      );

      const serviceNeeds = sortBy(payload.serviceNeed, 'ordering');

      const newState = {
        ...state,
        businessDefinedStates,
        configuredTags: payload.configuredTags,
        serviceNeeds,
        setDirtyAfterLeft: payload.tableDirtyAfterLeft,
        textingAvailable: (oc(payload.textingConfig) as any).textingAvailable(false),
        textingEnabled: (oc(payload.textingConfig) as any).textingEnabled(false),
        textMessageDefaults: (oc(payload.textingConfig) as any).textMessageDefault([]),
      };
      saveConfig(newState);
      return newState;
    }
    default: {
      return state;
    }
  }
}
